import { createFileRoute } from "@tanstack/react-router";

import ResetPasswordMessage from "@/features/auth/ResetPasswordMessage";
import BasicLayout from "@/layouts/Basic";

export const Route = createFileRoute("/reset-password-message")({
  component: () => (
    <BasicLayout>
      <ResetPasswordMessage />
    </BasicLayout>
  ),
});
